var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import sagaFactory from '../utils/sagaFactory';
export var deleteAddress = sagaFactory('deleteAddress', actions.removeAddress, callApi.deleteAddress, 'deleteAddress');
export var deleteAddressById = sagaFactory('deleteAddressById', actions.removeAddressById, callApi.deleteAddressById, 'deleteAddressById');
export var updateAddress = sagaFactory('updateAddress', actions.updateAddress, callApi.updateAddress, 'updateAddress');
export var upsertPreviousAddressTrip = sagaFactory('upsertPreviousAddressTrip', actions.upsertPreviousAddressTrip, callApi.upsertPreviousAddressTrip, 'upsertPreviousAddressTrip');
export var upsertPreviousAddressPackage = sagaFactory('upsertPreviousAddressPackage', actions.upsertPreviousAddressPackage, callApi.upsertPreviousAddressPackage, 'upsertPreviousAddressPackage');
export var createAddress = sagaFactory('createAddress', actions.createAddress, callApi.createAddress, 'createAddress');
export var createUserAddress = sagaFactory('createUserAddress', actions.createUserAddress, callApi.createUserAddress, 'createUserAddress');
function userSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.removeAddress.type.REQUEST, deleteAddress)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.removeAddressById.type.REQUEST, deleteAddressById)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updateAddress.type.REQUEST, updateAddress)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createAddress.type.REQUEST, createAddress)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createUserAddress.type.REQUEST, createUserAddress)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.upsertPreviousAddressPackage.type.REQUEST, upsertPreviousAddressPackage)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.upsertPreviousAddressTrip.type.REQUEST, upsertPreviousAddressTrip)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default userSaga;
//# sourceMappingURL=address.js.map